<template>
  <div class="delivery-info flex--align-center">
    <span class="icon delivery-info__box-icon">{{ $options.boxIcon }}</span>
    <span v-if="hasFreeDelivery" class="icon green-check-icon"></span>
    <div class="flex--column u-typography-helvetica u-text u-text--xs">
      <p class="delivery-info__text">{{ freeDeliveryStatus }}</p>
      <p v-if="!hasFreeDelivery" class="delivery-info__text">
        {{ freeDeliveryMessage }}
      </p>
    </div>
  </div>
</template>

<script>
import { ICON, ICON_VALUE } from '@/constants/icons';

export default {
  name: 'DeliveryNotification',
  boxIcon: ICON_VALUE[ICON.BOX],
  props: {
    hasFreeDelivery: {
      type: Boolean,
      default: false
    },
    freeDeliveryMessage: {
      type: String,
      default: ''
    },
    freeDeliveryStatus: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';
@import '../../assets/scss/cart.scss';
@import '../../assets/scss/icon.scss';

.delivery-info {
  position: relative;

  &__text {
    font-size: 1.4rem;
    color: var(--u-color-grey-900);

    &:first-child {
      font-weight: bold;
      margin-bottom: 4px;
    }
  }

  &__box-icon {
    margin-inline-end: 24px;
    color: $tuatara-color;
    font-size: 3.2rem;
  }
}

.green-check-icon {
  position: absolute;
  top: 32px;
  width: 14px;
  height: 14px;
  background-image: url(~@/assets/images/green-check.svg);

  &:not(:lang(ar)) {
    left: 24px;
  }

  &:lang(ar) {
    right: 24px;
  }
}

.green-check-icon:lang(ar) {
  top: 32px;

  &:not(:lang(ar)) {
    right: 4px;
  }

  &:lang(ar) {
    right: 0;
  }
}
</style>
